/**
 * Valores por defecto del CMS (deben coincidir con api/lib/Content.php)
 */
import {
  FEATURES, NEWS, FAQ, ROADMAP, VOTE_SITES, CLASSES, NPC_FEATURES,
  EVENTS_SCHEDULE, ENCHANT_RATES, RATES, SERVER_INFO,
} from "./mock";

export const CONTENT_DEFAULTS = {
  "site.seo": {
    page_title: "L2 Aetheris — Interlude x10 SubAcu",
    meta_description:
      "Servidor Lineage 2 Interlude con SubAcu Base +5, eventos automáticos, rates balanceados y comunidad activa.",
    og_title: "L2 Aetheris — Interlude SubAcu",
    og_description:
      "Servidor Lineage 2 Interlude con SubAcu Base +5, eventos automáticos y rates balanceados.",
    og_image: "/og-image.jpg",
  },
  "layout.brand": {
    name: "L2 AETHERIS",
    tagline: "Interlude · Premium",
  },
  "layout.topbar": {
    rates_line: "Interlude · x10 · SubAcu Base +5",
  },
  "home.hero": {
    eyebrow: "Interlude · SubAcu Base +5",
    logo_url: "",
    logo_max_height: "180",
    title_1: "La Era de",
    title_2: "AETHERIS",
    subtitle:
      "La nueva era del Lineage 2 ha comenzado. Un servidor Interlude reimaginado con sistemas SubAcu+5, interface custom y eventos cinematográficos.",
    opening_label: "Grand Opening",
    opening_date_text: "15 Ago 2025 · 21:00 GMT",
    opening_iso: SERVER_INFO.openingDate,
    cd_digit_color: "#d4a843",
    cd_label_color: "#8a8a92",
    cd_bg: "rgba(17,17,24,0.75)",
    cd_border_color: "rgba(212,168,67,0.25)",
    cd_border_width: "1",
    cd_radius: "6",
    cd_shadow: "",
    cd_shimmer: true,
    date_color: "#8a8a92",
    date_icon_color: "#d4a843",
    date_bg: "",
    date_border_color: "",
    date_border_width: "0",
    date_radius: "4",
    date_padding: "",
    cta_primary_text: "Descargar Cliente",
    cta_primary_link: "/downloads",
    cta_secondary_text: "Server Info",
    cta_secondary_link: "/wiki",
  },
  "home.server_info": {
    eyebrow: "Server Info · Wiki",
    title: "Toda la Información",
    subtitle: "Rates, mecánicas, NPCs, clases y todo lo que necesitas saber antes del Grand Opening.",
  },
  "home.sections": {
    features: true,
    server_info: true,
    news: true,
    votes: true,
    roadmap: true,
    faq: true,
  },
  "theme.branding": {
    logo_url: "",
    favicon_url: "",
    color_gold: "#d4a843",
    color_gold_light: "#f5c542",
    color_gold_dark: "#8b6914",
    color_text: "#f0ebe0",
    color_muted: "#b8b3a8",
    color_bg: "#0a0a0d",
    bg_hero: "https://images.unsplash.com/photo-1585588985526-9459c1bb9e9e?auto=format&fit=crop&w=1920&q=85",
    bg_hero_overlay: "55",
    bg_wiki: "https://images.unsplash.com/photo-1514539079130-25950c84af65?auto=format&fit=crop&w=1920&q=80",
    bg_news: "https://images.unsplash.com/photo-1773216344148-45afea590cf6?auto=format&fit=crop&w=1920&q=80",
    bg_server_info: "",
    bg_sections_opacity: "20",
  },
  "home.features_header": {
    eyebrow: "Por qué Aetheris",
    title: "Características Únicas",
    subtitle:
      "Una experiencia Interlude refinada con sistemas modernos, balance competitivo y atención al detalle en cada rincón del servidor.",
  },
  "home.features": FEATURES,
  "home.news_header": {
    eyebrow: "Últimas Noticias",
    title: "Crónicas del Reino",
  },
  "news.list": NEWS,
  "news.page_header": {
    eyebrow: "Crónicas",
    title: "Noticias del Reino",
    subtitle: "Patches, eventos, anuncios y todo lo que ocurre en Aetheris.",
  },
  "home.votes_header": {
    eyebrow: "Vota & Recibe",
    title: "Apoya el Reino",
    description:
      "Vota cada 12 horas en los sitios oficiales y obtén Vote Coins que puedes canjear por items únicos en el Vote Shop. Tu apoyo ayuda a Aetheris a crecer.",
  },
  "home.votes_stats": [
    { label: "4 Sitios", sub: "votables" },
    { label: "180+ ", sub: "vote coins/día" },
    { label: "12h", sub: "cooldown" },
  ],
  "home.votes_sites": VOTE_SITES,
  "home.roadmap_header": {
    title: "Roadmap 2025 / 2026",
    subtitle: "Nuestro camino hacia el mejor servidor Interlude de la región.",
  },
  "home.roadmap": ROADMAP,
  "home.faq_header": {
    eyebrow: "FAQ",
    title: "Preguntas Frecuentes",
  },
  "home.faq": FAQ,
  "wiki.tabs": [
    { id: "rates", label: "Rates", icon: "Coins", kind: "rates", section_title: "Rates del Servidor", section_subtitle: "Tasas configuradas para una experiencia balanceada." },
    { id: "enchant", label: "Enchant", icon: "Sparkles", kind: "enchant", section_title: "Sistema de Enchant", section_subtitle: "Tasas y límites por tipo de scroll." },
    { id: "classes", label: "Clases", icon: "Crown", kind: "classes", section_title: "Clases & Roles", section_subtitle: "Arquetipos y subclases." },
    { id: "npc", label: "NPCs", icon: "Shield", kind: "npc", section_title: "NPCs Custom", section_subtitle: "Servicios en las main towns." },
    { id: "events", label: "Eventos", icon: "Swords", kind: "events", section_title: "Calendario de Eventos", section_subtitle: "Eventos diarios automáticos." },
    { id: "guide", label: "Guía", icon: "BookOpen", kind: "guide", section_title: "Guía de Inicio", section_subtitle: "Primeros pasos en el servidor." },
  ],
  "wiki.header": {
    eyebrow: "Server Info",
    title: "Wiki del Reino",
    subtitle: "Toda la información del servidor en un solo lugar. Rates, mecánicas, clases, NPCs y mucho más.",
  },
  "wiki.rates": Object.values(RATES),
  "wiki.enchant_rates": ENCHANT_RATES,
  "wiki.classes": CLASSES,
  "wiki.npcs": NPC_FEATURES,
  "wiki.events": EVENTS_SCHEDULE,
  "wiki.guide_steps": [
    { step: "01", title: "Descarga el cliente", text: "Descarga el cliente Interlude desde nuestra sección de descargas. Tamaño: 5.8 GB." },
    { step: "02", title: "Crea tu cuenta", text: "Regístrate gratis desde la web. Una cuenta puede tener hasta 7 personajes." },
    { step: "03", title: "Configura el cliente", text: "Edita el archivo l2.ini y apunta el server IP a aetheris.gameserver:7777" },
    { step: "04", title: "Únete al Discord", text: "Tu mejor recurso para encontrar party, clan, y noticias en tiempo real." },
    { step: "05", title: "Vota & gana rewards", text: "Vota cada 12 horas para obtener Vote Coins canjeables en el Vote Shop." },
  ],
  "wiki.sections": [],
  "downloads.intro":
    "Descarga el cliente Interlude completo. Instalación automática, sin patches manuales.",
  "downloads.list": [
    { name: "Mirror Europa", url: "#", size: "5.8 GB", type: "mirror", description: "Servidor Europa - 100 Mbps" },
    { name: "Mirror América", url: "#", size: "5.8 GB", type: "mirror", description: "Servidor US - 100 Mbps" },
    { name: "Torrent", url: "#", size: "5.8 GB", type: "torrent", description: "P2P - Velocidad ilimitada" },
  ],
  "nav.items": [
    { label: "Inicio", url: "/", external: false },
    { label: "Server Info", url: "/wiki", external: false },
    { label: "Noticias", url: "/news", external: false },
    { label: "Rankings", url: "/rankings", external: false },
    { label: "Descargas", url: "/downloads", external: false },
  ],
  "footer.about":
    "Un servidor Interlude reimaginado con rates balanceados, anti-cheat activo y una comunidad apasionada.",
  "footer.copyright": "L2 AETHERIS · No afiliado con NCSoft.",
  "footer.social": [{ platform: "discord", url: "https://discord.gg/aetheris" }],
  "footer.columns": [
    {
      title: "Servidor",
      links: [
        { label: "Server Info", url: "/wiki" },
        { label: "Noticias", url: "/news" },
        { label: "Rankings", url: "/rankings" },
        { label: "Descargas", url: "/downloads" },
      ],
    },
    {
      title: "Comunidad",
      links: [
        { label: "Discord", url: "#" },
        { label: "Forum", url: "#" },
        { label: "Wiki", url: "#" },
      ],
    },
  ],
  "footer.brand": {
    name: "L2 AETHERIS",
    tagline: "Interlude · Premium",
  },
  "legal.pages": [
    {
      slug: "terms",
      title: "Términos y Condiciones",
      footer_label: "Términos",
      eyebrow: "Legal",
      show_in_footer: true,
      body:
        "## 1. Aceptación\n\nAl registrarte y usar este sitio y los servidores de juego aceptas estos Términos y Condiciones. Si no estás de acuerdo, no uses el servicio.\n\n## 2. Naturaleza del servicio\n\nEste es un servidor privado de Lineage 2 con fines de **entretenimiento**. No está afiliado a NCSoft. Todos los items y la moneda del juego son bienes digitales sin valor monetario real fuera del juego.\n\n## 3. Cuenta de usuario\n\n- Eres responsable de mantener segura tu contraseña.\n- No compartas tu cuenta con terceros.\n- Está prohibido el uso de bots, hacks o software de terceros.\n- El multi-cuenta abusivo puede ser sancionado según las reglas del servidor.\n\n## 4. Donaciones y bienes digitales\n\nLas donaciones otorgan **Donate Coins** que se acreditan a tu cuenta. Por la naturaleza digital e inmediata de la entrega, **todas las ventas son finales**. Ver la Política de Reembolsos para excepciones.\n\n## 5. Sanciones\n\nEl staff puede suspender o eliminar cuentas que violen estos términos o las reglas del juego, sin obligación de reembolso.\n\n## 6. Cambios\n\nEstos términos pueden actualizarse en cualquier momento. El uso continuado del servicio implica la aceptación de los cambios.",
    },
    {
      slug: "privacy",
      title: "Política de Privacidad",
      footer_label: "Privacidad",
      eyebrow: "Legal",
      show_in_footer: true,
      body:
        "## Compromiso con tu privacidad\n\nRespetamos tu privacidad. Esta política explica qué datos recopilamos y cómo los usamos. No vendemos ni alquilamos tu información personal a terceros con fines de marketing.\n\n## Datos que recopilamos\n\n- Datos de cuenta (usuario, email).\n- Datos técnicos (IP, navegador) para seguridad y auditoría.\n- Datos de donaciones procesados de forma segura por las pasarelas de pago.\n\n## Seguridad\n\nUsamos cifrado SSL en los formularios sensibles. Los datos de pago se procesan en los servidores de las pasarelas (PayPal, MercadoPago, Khipu, etc.) y **no se almacenan** en nuestro sitio.\n\n## Terceros\n\nLos datos personales solo se comparten ante requerimientos legales o con tu consentimiento explícito.\n\n## Cambios\n\nPodemos actualizar esta política. Revisa esta página periódicamente para estar al tanto de los cambios.",
    },
    {
      slug: "rules",
      title: "Reglas del Servidor",
      footer_label: "Reglas",
      eyebrow: "Comunidad",
      show_in_footer: true,
      body:
        "## Reglas generales\n\n1. **Respeto:** trata con respeto a todos los jugadores y al staff.\n2. **Sin cheats:** prohibido el uso de bots, hacks, exploits o software de terceros.\n3. **Sin multi-cuenta abusivo:** revisa los límites permitidos de cajas/ventanas.\n4. **Sin scam:** estafar a otros jugadores está prohibido.\n5. **Sin spam ni publicidad** de otros servidores.\n6. **Idioma:** mantén el chat global en un lenguaje apropiado, sin insultos ni discriminación.\n\n## Sanciones\n\nLas violaciones pueden resultar en advertencias, mute, jail o ban permanente según la gravedad, a criterio del staff.\n\n## Soporte\n\nPara reportar a un jugador o resolver dudas, contáctanos en Discord.",
    },
  ],
  "account.panel": {
    eyebrow: "Panel de Cuenta",
    stat_characters: "Personajes",
    stat_coins: "Donate Coins",
    stat_orders: "Donaciones",
    stat_access: "Acceso",
    donate_cta_title: "Donar al Servidor",
    donate_cta_text: "Apoya al servidor y recibí Donate Coins con bonos de hasta +25%",
    banner_ok_title: "¡Donación confirmada!",
    banner_ok_msg: "Tus coins fueron acreditados. Reclámalos en el juego con el comando .claim",
    banner_fail_title: "Donación rechazada",
    banner_fail_msg:
      "El pago no se completó. Si crees que es un error, contacta soporte con la orden {order}.",
    banner_pending_title: "Pago en revisión",
    banner_pending_msg: "Tu pago está siendo procesado. Te llegará un email cuando se confirme.",
    characters_title: "Tus Personajes",
    characters_empty: "No tienes personajes en esta cuenta aún.",
    history_title: "Historial de Donaciones",
    history_empty: "Sin donaciones aún.",
  },
  "account.backup": {
    file_title: "CUENTA DEL SERVIDOR",
    filename_prefix: "cuenta",
    intro_register: "Bienvenido. Guarda este archivo en un lugar seguro!",
    intro_recover: "Tu contraseña fue restablecida correctamente.",
    intro_change: "Tu contraseña fue actualizada correctamente.",
    instructions:
      "1. Guarda este archivo en un lugar seguro (NO en la nube publica).\n" +
      "2. Tu password queda registrada en el servidor del juego.\n" +
      "3. Si pierdes el acceso, podras recuperar la cuenta con tu email y la\n" +
      "   respuesta a tu pregunta secreta desde la pagina de login.\n" +
      "4. Nunca compartas tu password ni tu respuesta secreta con nadie.\n" +
      "5. El staff del servidor NUNCA te pedira tu password.",
    server_label: "Servidor:",
    server_url: "l2iris.com",
    support_label: "Soporte:",
    support_contact: "https://discord.gg/KCbBprh7Bk",
  },
  "layout.vote_banners": [
    {
      enabled: true,
      name: "HopZone",
      href: "https://l2.hopzone.net/site/vote/105491/1",
      image: "https://l2.hopzone.net/assets/img/banners/vote_banners/banner_6.png",
      alt: "Vote for L2SHINSEKAI.COM",
      title: "L2.HOPZONE.NET - Lineage 2 Servers ranking",
      position: "bottom-right",
      width: "140",
      height: "120",
      new_tab: true,
    },
    {
      enabled: true,
      name: "L2Network",
      href: "https://l2network.eu/index.php?a=in&u=L2Shinsekai",
      image: "https://l2network.eu/images/tlsidebanner.png",
      alt: "L2Network",
      title: "L2Network",
      position: "top-left",
      width: "145",
      height: "122",
      new_tab: true,
    },
    {
      enabled: true,
      name: "Top L2JBrasil",
      href: "https://top.l2jbrasil.com/index.php?a=in&u=Shinigami",
      image: "https://top.l2jbrasil.com/button_new.php?u=Shinigami",
      alt: "Top L2JBrasil de Servidores de Lineage2",
      title: "Top L2JBrasil de Servidores de Lineage2",
      position: "top-right",
      width: "235",
      height: "90",
      new_tab: true,
    },
  ],
  "donate.config": {
    product_name: "L2 Aetheris - Donate Coins",
    brand_name: "L2 Aetheris",
    method_paypal: true,
    method_mp_ar: true,
    method_mp_cl: true,
    method_khipu_cl: true,
    method_khipu_ar: true,
    method_flow_cl: true,
    method_dlocal_go: true,
    method_paymentwall: true,
    method_crypto: true,
    name_paypal: "PayPal",
    desc_paypal: "Tarjeta o saldo PayPal",
    name_mp_ar: "MercadoPago AR",
    desc_mp_ar: "Tarjeta / dinero en cuenta / Rapipago",
    name_mp_cl: "MercadoPago CL",
    desc_mp_cl: "Tarjeta chilena / dinero en cuenta",
    name_khipu_cl: "Khipu Chile",
    desc_khipu_cl: "Transferencia bancaria chilena",
    name_khipu_ar: "Khipu Argentina",
    desc_khipu_ar: "Transferencia bancaria argentina",
    name_flow_cl: "Flow Chile",
    desc_flow_cl: "Webpay, tarjetas y transferencia (Chile)",
    name_dlocal_go: "dLocal Go",
    desc_dlocal_go: "Pagos internacionales — ves el monto en tu moneda al pagar",
    name_paymentwall: "Paymentwall",
    desc_paymentwall: "Tarjetas y metodos de pago locales en tu pais (USD)",
    name_crypto: "USDT (Crypto)",
    desc_crypto: "USDT TRC20 / BEP20 / ERC20",
    rate_usd_amount: "1",
    rate_usd_coins: "1500",
    rate_usdt_amount: "1",
    rate_usdt_coins: "1500",
    rate_ars_amount: "1",
    rate_ars_coins: "1",
    rate_clp_amount: "1000",
    rate_clp_coins: "1500",
  },
  "account.donate": {
    eyebrow: "Donate Coins",
    title: "Apoya al Servidor",
    method_title: "Método de pago",
    amount_title: "Monto",
    email_title: "Email (obligatorio)",
    email_note: "Te enviaremos la confirmación de la donación a este email.",
    security_note:
      "Pago seguro mediante {method}. Tu IP, email y datos quedan registrados con auditoría completa.",
  },
};

export function contentFallback(key) {
  return CONTENT_DEFAULTS[key] ?? null;
}
